import React from "react";
import TwitterIcon from "@material-ui/icons/Twitter";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
export default function Footer() {
  return (
    <div className="footer">
      <div className="title-container">
        <span className="titles">More</span>
        <span className="subtitles">About Us</span>
        <span className="subtitles">Contact Us</span>
        <span className="subtitles">Our Offices</span>
      </div>
      <div className="title-container">
        <span className="titles">Hot Topics</span>
        <span className="subtitles">Fitness Programs</span>
        <span className="subtitles">Day creams</span>
        <span className="subtitles">Our Tutorials</span>
      </div>
      <div className="title-container">
        <span className="titles">Social</span>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              alignItems: "flex-start"
            }}
          >
            <FacebookIcon style={{ fontSize: "18px", marginRight: "3px" }} />
            <TwitterIcon style={{ fontSize: "18px", marginTop: "13px" }} />
            <InstagramIcon style={{ fontSize: "18px", marginTop: "12px" }} />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              alignItems: "flex-start"
            }}
          >
            <span className="subtitles">Facebook</span>
            <span className="subtitles">Twitter</span>
            <span className="subtitles">Instagram</span>
          </div>
        </div>
      </div>
    </div>
  );
}
